import { TableRow } from "@mui/material";
import styled from "styled-components";
import { COLORS } from "../../../constants/colors";
import { EplusTableRowProps } from "../../../constants/types";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { useCallback } from "react";
import { getStatusInfo } from "../../../constants/function";

const StyledTableRow = styled(TableRow)<any>(() => ({
  [`&`]: {
    background: "white",
    cursor: "pointer",
  },
  [`&.disconnect`]: {
    background: COLORS.lightGray,
  },
  [`&.high-temp`]: {
    background: COLORS.lightOrange2,
  },
  [`&.fire`]: {
    background: COLORS.lightRed,
  },
  [`&:hover`]: {
    background: COLORS.lightGray3,
  },
  [`&:nth-of-type(even)`]: {
    padding: "0.65%",
    fontSize: "1em",
    fontWeight: 600,
    color: COLORS.fontColor,
  },
}));

const EplusTableRow = (props: EplusTableRowProps) => {
  const onClick = useCallback(() => {
    window.open(props.data.link, "_blank");
  }, []);
  return (
    <StyledTableRow
      onClick={onClick}
      className={getStatusInfo(props.data.status).name}
    >
      <PublicStyledTableCell>{props.data.projectName}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.panelName}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.id}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.temperature}</PublicStyledTableCell>
      <PublicStyledTableCell>
        {props.data.referenceTemperature}
      </PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.note}</PublicStyledTableCell>
    </StyledTableRow>
  );
};

export default EplusTableRow;
